import React from 'react';
import { PageLayout } from '../components/layout/PageLayout';

const services = [
  { name: "API Gateway", status: "operational", uptime: "99.99%" },
  { name: "Transaction Processing", status: "operational", uptime: "99.99%" },
  { name: "Merchant Dashboard", status: "operational", uptime: "100%" },
  { name: "Webhooks & Events", status: "operational", uptime: "99.98%" },
  { name: "Payouts Engine", status: "operational", uptime: "99.99%" },
  { name: "Radar (Fraud Detection)", status: "operational", uptime: "100%" },
  { name: "Tapn NFC Service", status: "operational", uptime: "99.97%" },
  { name: "Tarry AI Concierge", status: "operational", uptime: "99.95%" },
];

const incidents = [
  { date: "April 20, 2026", title: "Scheduled Maintenance — Database Migration", status: "Completed", desc: "Performed zero-downtime migration of transaction ledger tables. No customer impact." },
  { date: "April 12, 2026", title: "Elevated Latency — EU Region", status: "Resolved", desc: "Brief latency increase (avg +80ms) on EU API endpoints due to upstream CDN provider. Mitigated by failover to backup edge nodes." },
  { date: "March 28, 2026", title: "Webhook Delivery Delays", status: "Resolved", desc: "Queue backlog caused webhook deliveries to be delayed by up to 15 minutes. Root cause: memory pressure on worker nodes. Resolved by scaling worker fleet." },
];

export default function Status() {
  const allOperational = services.every(s => s.status === "operational");

  return (
    <PageLayout
      title="System Status"
      subtitle="Real-time operational status of all Paygent services."
      badge="UPTIME"
    >
      <div className="max-w-4xl mx-auto">
        {/* Overall Status Banner */}
        <div className={`rounded-2xl p-6 mb-10 text-center ${allOperational ? 'bg-green-50 border border-green-200' : 'bg-amber-50 border border-amber-200'}`}>
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 ${allOperational ? 'bg-green-100' : 'bg-amber-100'}`}>
            <i className={`${allOperational ? 'ri-check-line text-green-600' : 'ri-alert-line text-amber-600'} text-xl w-6 h-6 flex items-center justify-center`} />
          </div>
          <h2 className={`text-xl font-bold ${allOperational ? 'text-green-800' : 'text-amber-800'}`}>
            {allOperational ? 'All Systems Operational' : 'Partial Service Disruption'}
          </h2>
          <p className="text-sm text-gray-500 mt-1">Last checked: {new Date().toLocaleString()}</p>
        </div>

        {/* Service Grid */}
        <div className="space-y-3 mb-16">
          {services.map(s => (
            <div key={s.name} className="flex items-center justify-between p-4 bg-white rounded-xl border border-gray-100 shadow-sm">
              <div className="flex items-center gap-3">
                <div className={`w-2.5 h-2.5 rounded-full ${s.status === 'operational' ? 'bg-green-500' : s.status === 'degraded' ? 'bg-amber-500' : 'bg-red-500'}`} />
                <span className="font-medium text-gray-900 text-sm">{s.name}</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-xs text-gray-400">{s.uptime} uptime</span>
                <span className={`text-xs font-bold uppercase tracking-wide ${s.status === 'operational' ? 'text-green-600' : 'text-amber-600'}`}>
                  {s.status}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Recent Incidents */}
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Recent Incidents</h2>
          <div className="space-y-6">
            {incidents.map(inc => (
              <div key={inc.date} className="border-l-4 border-gray-200 pl-6">
                <div className="flex items-center gap-3 mb-1">
                  <span className="text-sm text-gray-400">{inc.date}</span>
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${inc.status === 'Resolved' ? 'bg-green-50 text-green-700' : inc.status === 'Completed' ? 'bg-blue-50 text-blue-700' : 'bg-amber-50 text-amber-700'}`}>
                    {inc.status}
                  </span>
                </div>
                <h3 className="font-bold text-gray-900 mb-1">{inc.title}</h3>
                <p className="text-sm text-gray-500">{inc.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
